<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row>
          <el-col class="search-wrapper">
            <div class="search-left">
              <el-form
                :inline="true"
                :model="searchCondition"
                class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="searchCondition.status"
                    class="select"
                    @change="selectClick">
                    <el-option label="全部审核状态" value=""></el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="searchCondition.channel_name"
                    placeholder="输入渠道号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchButton"
                    >查询</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <el-button type="primary" @click="addButton"
              v-if="userPermissions.indexOf('oem_create') != -1"
              >添加OEM</el-button
            >
          </el-col>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="list"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="LOGO">
            <template slot-scope="scope">
              <img :src="scope.row.logo" style="width: 100%" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
             <div>{{scope.row.alias_status}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" @click="updateButton(scope.row.id,scope.row.name,scope.row.alias_name,scope.row.url,scope.row.logo)" v-if="userPermissions.indexOf('oem_edit') != -1">修改</el-button>
                <!-- <el-popover
                  v-if="scope.row.alias_status != '待审核'"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible"
                >
                  <p>确定要禁用记录吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="disableButton(scope.row.id, scope.row.status)"
                      >确定</el-button
                    >
                  </div>
                  <el-button slot="reference" type="danger" size="mini" v-if="userPermissions.indexOf('oem_status') != -1 && scope.row.status == '1'">禁用</el-button>
                  <el-button slot="reference" type="success" size="mini" v-if="userPermissions.indexOf('oem_status') != -1 && scope.row.status == '3'">启用</el-button>
                </el-popover> -->
                <el-popover
                  placement="top"
                  width="150"
                  v-model="scope.row.visible"
                >
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteButton(scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button slot="reference" type="danger" size="mini">删除</el-button>
                </el-popover>
                <el-button size="mini" type="text" @click="toExamine(scope.row.id)"  v-if="userPermissions.indexOf('oem_audit') != -1 && scope.row.alias_status == '待审核'">审核</el-button>

              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
     <!-- 审核模态框 -->
    <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status" @change="selectRadio">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 3">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.check_remark" placeholder="请输入拒绝原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from "vuex"
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  data() {
    return {
       examineDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {//审核表单数据
        id: '',
        status: '',
        check_remark: ''
      },
      imageUrl: "",
      value: "",
      options: [
        {
          value: "1",
          label: "通过",
        },
        {
          value: "0",
          label: "审核中",
        },
        {
          value: "2",
          label: "禁用",
        },
      ],
      searchCondition: {
        status: ""
      },
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [
        {
          title: "公司名称",
          value: "name",
          header_align: "center",
          align: "center",
        },
        {
          title: "公司别称",
          value: "alias_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "域名",
          value: "url",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
        // {
        //   title: "状态",
        //   value: "status",
        //   header_align: "center",
        //   align: "center",
        // },
      ],
      list: [],
    };
  },
  watch: {
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    },
    "$route.matched": function(n) {
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    //审核
    toExamine(id) {
      this.examineDialogData.title = `审核${id}`
      this.examineDialogData.visible = true
      this.examineRuleForm.id = id
    },
    //审核
    async oemAudit() {
      let args = {
        status: this.examineRuleForm.status
      }
      let result = await this.$api.oemAudit(this.examineRuleForm.id, args)
      if(result) {
        // 调用组件的数据验证方法
        this.examineRuleForm = {}
        this.examineDialogData.visible = false
      }
    },
    // 处理审核模态框，确定事件
    examineHandleConfirm() {
     this.oemAudit()
    },
    //处理审核模态框，关闭事件
    examineDialogClose() {
      this.examineRuleForm = {}
      this.examineDialogData.visible = false
    },
    //审核状态单选操作
    selectRadio() {
      if(this.examineRuleForm.status == 2) {
        this.examineRuleForm.check_remark = ''
      }
    },
    //按状态塞选数据
    selectClick(event) {
      if(event == '1'){
        this.searchCondition.status = event
        this.init('1')
      }
      if(event == '0'){
        this.searchCondition.status = event
        this.init('0')
      }
      if(event == '2'){
        this.searchCondition.status = event
        this.init('2')
      }
      console.log(event, this.searchCondition.status,"value")
    },
    //添加OEM
    addButton() {
      this.$router.push(this.$route.path + "/create");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    //初始化oem列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let { data, pages} = await this.$api.getOemlist(searchCondition)
        this.$nextTick(() => {
          this.list=data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.channel_name) {
        condition.channel_name = this.searchCondition.channel_name;
      }
      if(this.searchCondition.status) {
        condition.status = this.searchCondition.status
      }
      return condition;
    },
    //修改oem配置
    async updateButton(id, name,alias_name,url,logo) {
      this.$router.push({ path: this.$route.path + "/" + id + "/edit", query: {id: id, name: name,alias_name:alias_name,url:url,logo:logo}});
    },
    //禁用oem
    async disableButton(id, oemStatus) {
      console.log(oemStatus,"oemStatus")
      var status
      switch(oemStatus) {
        case 1: status = 3; break;
        case 3: status = 1; break;
        default: break;
      }
      let args = {
        status: status
      }
      let result = await this.$api.alterStatus(id, args)
      if(result) {
        this.init()
      }
    },
    async deleteButton(id) {
      let result = await this.$api.deleteOem(id)
      if(result) {
        this.init()
      }
    },
    //搜索
    searchButton() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.search-wrapper {
  height: 36px;
  display: flex;
  justify-content: space-between;
}

.search-left {
  display: flex;
}

.select {
  width: 150px;
}
</style>
